import { render, staticRenderFns } from "./Chatbot.vue?vue&type=template&id=03a94f0d&scoped=true"
import script from "./Chatbot.vue?vue&type=script&lang=js"
export * from "./Chatbot.vue?vue&type=script&lang=js"
import style0 from "./Chatbot.vue?vue&type=style&index=0&id=03a94f0d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a94f0d",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductsFeatures: require('/home/rohit/Documents/GitHub/aibuddha-website/components/ProductsFeatures.vue').default,Testimonials: require('/home/rohit/Documents/GitHub/aibuddha-website/components/Testimonials.vue').default,MidBanner: require('/home/rohit/Documents/GitHub/aibuddha-website/components/MidBanner.vue').default})
